import React, { Fragment } from 'react';
import Head from 'next/head';
import { arrayOf, shape, string } from 'prop-types';
import AmpProductTeaserListItem from '../AmpProductTeaserListItem';

function AmpProductTeaserList(props) {
  const { products, titleHtml } = props;

  if (!products || !products.length) {
    return null;
  }

  return (
    <Fragment>
      <Head>
        <script
          key="amp-timeago"
          async
          custom-element="amp-timeago"
          src="https://cdn.ampproject.org/v0/amp-timeago-0.1.js"
        />
      </Head>

      <div className="AmpProductTeaserList">
        {titleHtml && (
          <div
            className="AmpProductTeaserList__heading"
            dangerouslySetInnerHTML={{ __html: titleHtml }}
          />
        )}
        {products.map((product, index) => (
          <AmpProductTeaserListItem
            key={product.url}
            num={index + 1}
            total={products.length}
            {...product}
          />
        ))}
      </div>
    </Fragment>
  );
}

AmpProductTeaserList.propTypes = {
  products: arrayOf(
    shape({
      url: string
    })
  ),
  titleHtml: string
};

AmpProductTeaserList.defaultProps = {
  products: undefined,
  titleHtml: undefined
};

export default AmpProductTeaserList;
